import { observer } from 'mobx-react-lite';
import { FC, useRef } from 'react';

import { IcSmileIcon } from '@gem/icons';
import { FAB, Popover } from '@gem/ui-kit';

import { EmojiStickersPanel } from './EmojiStickersPanel/EmojiStickersPanel';
import { useEmojisStickersButtonPresenter } from './EmojisStickersButton.presenter';
import styles from './EmojisStickersButton.styles.m.css';

export const EmojisStickersButton: FC = observer(() => {
  const presenter = useEmojisStickersButtonPresenter();
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <>
      <FAB
        className={styles.button}
        setRef={ref}
        onClick={presenter.onToggle}
        size="10"
        theme={presenter.isOpened ? '2_1' : '2'}
        Icon={IcSmileIcon}
      />
      <Popover
        isScrollEnabled
        className={styles.popover}
        isOpened={presenter.isOpened}
        placement="top-end"
        reference={ref.current}
        onClose={presenter.onClose}
      >
        <EmojiStickersPanel closePopover={presenter.onClose} />
      </Popover>
    </>
  );
});
